module.exports = __webpack_public_path__ + "static/Service-hero-2-8029f72a0ff29925840771c793b54d68.png";